/**
 * @generated SignedSource<<cce2420c0885ee6e43940d1744e367a1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueKey_nativeIssueTable_IssueKeyCell_fieldRef$data = {
  readonly hoverOrFocusState?: {
    readonly " $fragmentSpreads": FragmentRefs<"popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent">;
  } | null | undefined;
  readonly text: string | null | undefined;
  readonly " $fragmentType": "issueKey_nativeIssueTable_IssueKeyCell_fieldRef";
};
export type issueKey_nativeIssueTable_IssueKeyCell_fieldRef$key = {
  readonly " $data"?: issueKey_nativeIssueTable_IssueKeyCell_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueKey_nativeIssueTable_IssueKeyCell_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "issueKey_nativeIssueTable_IssueKeyCell_fieldRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "text"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "concreteType": "JiraFieldHoverOrFocusState",
              "kind": "LinkedField",
              "name": "hoverOrFocusState",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "popoverWithRelay_hoverPopover_HoverPopoverWithRelayComponent"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "e37c1089d21d3ada52d098d0cded34d7";

export default node;
